module.exports = __webpack_public_path__ + "static/ranking-0f96d54330c08ca9cd62fa3f5740b5ed.png";